import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, mergeApplicationConfig } from '@angular/core';
import { commonAppConfig } from '@ui/layout/common-app/common-app.config';
import { AppRoutingModule } from './app-routing.module';
import { ThirdLevelMenuFactory } from '@core/menu/third-level-menu.service';
import { thirdLevelMenu } from './sub.menu';
import { AppearanceState } from './shared/state/appearance.state';
import { AdvertisingState } from './shared/state/advertising.state';
import { ParametersState } from './shared/state/parameters.state';


export const loadSubMenu: (thirdLevelMenuFactory: ThirdLevelMenuFactory) => void =
    (thirdLevelMenuFactory: ThirdLevelMenuFactory) => () =>
        thirdLevelMenuFactory.loadMenu(thirdLevelMenu);

export const appConfig: ApplicationConfig = mergeApplicationConfig(commonAppConfig, {
    providers: [
        importProvidersFrom(AppRoutingModule),
        AppearanceState,
        AdvertisingState,
        ParametersState,
        {
            provide: APP_INITIALIZER,
            useFactory: loadSubMenu,
            deps: [ThirdLevelMenuFactory],
            multi: true,
        },
    ],
});
